import { ReactNode } from 'react';
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { invalidateEventQueries } from './hooks/events/utils/invalidate-event-queries';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: true, // refetch only when data is stale (controlled by staleTime)
      staleTime: 10 * 1000, // 10s — data is fresh for 10s, avoiding redundant refetches on tab switches
      retry: false, // Defaulting to false as we handle it in generic hooks or specific queries
    },
  },
  mutationCache: new MutationCache({
    onSuccess: async (_data, _variables, _context, mutation) => {
      const eventId = mutation.options.meta?.eventId as string | undefined;

      // Automatically invalidate event-related queries when mutation has eventId in meta
      if (eventId) {
        await invalidateEventQueries(queryClient, eventId);
      }
    },
  }),
});

export const QueryClientComponent = ({ children }: { children: ReactNode }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
